import { action, computed, observable, set, makeObservable } from 'mobx';
import { DeedDocumentType } from '../classes/DeedDocumentType';
import { IRecordedDeedRequired, IRecordedDeed, constructNewRecordedDeed } from '../classes/RecordedDeed';

// type RecordedDeedProperties = Object.keys(RecordedDeed);

export class RecordedDeedService {
  private recordedDeed: IRecordedDeed = observable.object(constructNewRecordedDeed());

  private requiredFields: IRecordedDeedRequired = observable.object({
    book: false,
    consideration: false,
    document_type: true,
    estate_type: true,
    execution_date: true,
    existing: false,
    grantee: true,
    grantor: true,
    instrument_number: false,
    other_document_type: false,
    recorded_at: true,
    recorded_date: true,
  });

  constructor() {
    makeObservable(this, {
      setRecordedDeeds: action,
      setRequiredField: action,
      getRecordedDeeds: computed,
      getRequiredFields: computed,
      recordedDeedReadyForSave: computed,
    });
  }

  public setRecordedDeeds(newRecordedDeed: IRecordedDeed) {
    set(this.recordedDeed, newRecordedDeed);
    this.setRequiredField('other_document_type', newRecordedDeed.document_type === DeedDocumentType.other);
  }

  public setRequiredField(propName: string, value: boolean) {
    set(this.requiredFields, propName, value);
  }

  public get getRecordedDeeds(): IRecordedDeed {
    return this.recordedDeed;
  }

  public get getRequiredFields(): IRecordedDeedRequired {
    return this.requiredFields;
  }

  public get recordedDeedReadyForSave(): boolean {
    let readyForSave = true;
    Object.keys(this.getRequiredFields).forEach((property) => {
      if (this.getRequiredFields[property] && !this.getRecordedDeeds[property]) {
        readyForSave = false;
      }
    });
    if (!this.getRecordedDeeds.book && !this.getRecordedDeeds.instrument_number) {
      readyForSave = false;
    }
    return readyForSave;
  }
}
